import { render, staticRenderFns } from "./SkeletonBanner.vue?vue&type=template&id=19cc7bcf&"
import script from "./SkeletonBanner.vue?vue&type=script&lang=js&"
export * from "./SkeletonBanner.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBanner.vue?vue&type=style&index=0&id=19cc7bcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports